import { useEffect } from 'react';
import { useEthers } from '@usedapp/core';
import { useAppDispatch, useAppSelector } from './hooks';
import { setActiveAccount, setAccountNfts } from './state/slices/account';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { setAlertModal } from './state/slices/application';
import classes from './App.module.css';
import '../src/css/globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AlertModal from './components/Modal';
import NavBar from './components/NavBar';
import NetworkAlert from './components/NetworkAlert';
import Footer from './components/Footer';
import GovernancePage from './pages/Governance';
import CreateProposalPage from './pages/CreateProposal';
import VotePage from './pages/Vote';
import NotFoundPage from './pages/NotFound';
import { CHAIN_ID } from './config';
import VerifyPage from './pages/Verify';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import axios from 'axios';
import * as ethers from 'ethers';
import config from './config';
import { BeeNFTABI } from '@nouns/contracts';

function App() {
  const { account, chainId } = useEthers();
  const dispatch = useAppDispatch();
  dayjs.extend(relativeTime);

  useEffect(() => {
    // Local account array updated
    dispatch(setActiveAccount(account));
    if (account) {
      getBees();
    }
  }, [account, dispatch]);

  const alertModal = useAppSelector(state => state.application.alertModal);

  const getBees = async () => {
    if (!window.ethereum as any) return;

    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();

    const beesContract = new ethers.Contract(config.beeNFTAddress, BeeNFTABI, signer);

    if (account) {
      try {
        const configAxios = {
          headers: {
            'Content-Type': 'application/json'
          },
        };

        const url = `https://api.etherscan.io/api?module=account&action=tokennfttx&contractaddress=${config.beeNFTAddress}&address=${account}&sort=asc&apikey=5M92P45ARYDDT154BICH6MKCSQ4971JHJS`;
        //const url = `https://api-rinkeby.etherscan.io/api?module=account&action=tokennfttx&contractaddress=${config.beeNFTAddress}&address=${account}&sort=asc&apikey=5M92P45ARYDDT154BICH6MKCSQ4971JHJS`; //for test

        const p = await axios.get(url);

        let nftIDs = p.data.result.map((x: any) => x.tokenID);

        nftIDs = Array.from(new Set(nftIDs));
        let myNFTs: any[] = [];

        const nftPromises = nftIDs.map(async (nft: any) => {
          const owner = await beesContract.ownerOf(nft);
          if (owner.toLowerCase() === account.toLowerCase()) {
            //const tokenURI = `https://api.opensea.io/api/v1/asset/${contractTest}/${nft}`; //for test
            const tokenURI = await beesContract.tokenURI(nft);
            const meta = await axios.get(tokenURI);

            myNFTs.push({
              ...meta.data,
              id: nft,
              openseaUrl: `https://opensea.io/assets/${config.beeNFTAddress}/${nft}`,
            });
          }
        });

        await Promise.all(nftPromises);
        console.log(myNFTs)
        dispatch(setAccountNfts(myNFTs));

      } catch (err) {
        console.log(err);
      }
    }
  };
  return (
    <div className={`${classes.wrapper}`}>
      {Number(CHAIN_ID) !== chainId && <NetworkAlert />}
      {alertModal.show && (
        <AlertModal
          title={alertModal.title}
          content={<p>{alertModal.message}</p>}
          onDismiss={() => dispatch(setAlertModal({ ...alertModal, show: false }))}
        />
      )}
      <BrowserRouter>
        <NavBar />
        <Switch>
          <Route exact path="/sign" component={VerifyPage} />
          <Route exact path="/verify" component={VerifyPage} />
          <Route exact path="/create-proposal" component={CreateProposalPage} />
          <Route exact path="/" component={GovernancePage} />
          <Route exact path="/vote/:id" component={VotePage} />
          <Route component={NotFoundPage} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
